var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye24Right(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 243,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-348 -132)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M547.064 218C530.79 267.53 484.257 303.076 430.028 303.076 427.432 303.076 424.819 302.986 422.188 302.824 395.569 301.145 370.969 291.005 351 274.242 351.649 283.174 352.37 292.232 353.451 302.03 356.19 327.074 369.383 346.814 391.586 359.102 406.364 367.294 424.026 371.516 442.283 372.671 473.533 374.638 506.622 367.619 530.105 356.269 554.922 344.27 571.052 322.672 574.368 296.995 577.666 271.464 567.988 244.236 547.064 218Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.59 137.004C362.241 146.932 350.54 178.54 350 232.478L350.702 233.706C366.85 257.515 393.421 273.852 424.295 275.801 426.348 275.928 428.4 276 430.434 276 477.852 276 517.727 241.034 525 194.335 522.93 192.44 521.022 190.509 518.826 188.631 451.947 131.408 402.405 129.838 385.59 137.004Z",
    fill: "#65471B",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.307 303C484.377 303 530.774 267.354 547 217.685 540.639 209.67 533.146 201.762 524.7 194 517.44 240.81 477.638 275.858 430.307 275.858 428.276 275.858 426.227 275.786 424.179 275.659 393.361 273.705 366.838 257.33 350.72 233.464L350.019 232.233C349.893 244.917 350.396 258.886 351.51 274.085 371.421 290.895 395.949 301.064 422.49 302.746 425.113 302.927 427.719 303 430.307 303Z",
    fill: "#F4900C",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 193C406 204.046 397.046 213.001 386 213.001 374.954 213.001 366 204.046 366 193 366 181.954 374.954 173 386 173 397.046 173 406 181.954 406 193Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye24Right);
export default __webpack_public_path__ + "static/media/eye24-right.5323fb87bb20fb0e63808f7e15781a50.svg";
export { ForwardRef as ReactComponent };